<template>
    <div class='payfree'>
        <span class='free' v-if='free'>{{$t("FREE")}}</span>
        <span class='buy' v-else-if='!bought'>{{$t("PAID")}}</span>
        <span class='bought' v-else>{{$t("BOUGHT")}}</span>
    </div>
</template>

<script>
import i18n from '@root/components/i18n';

export default {
    props: ["free", "bought"],
    mixins: [i18n],
    components: {
    },
    data() {
        return {
        };
    },
    methods: {
    }
}
</script>

<i18n>
{
    en: {
        FREE: "Free",
        PAID: "Buy",
        BOUGHT: "Bought",
    },
    ru: {
        FREE: "Бесплатно",
        PAID: "Платно",
        BOUGHT: "Куплено",
    }
}
</i18n>

<style lang="scss" scoped>
    .payfree {
        position: absolute;
        top: 4px;
        right: 4px;
    }
    .free, .buy, .bought {
        overflow: hidden;
        border-radius: 100px;
        padding: 4px 16px;
        font-weight: 600;
    }
    .free {
        background: #169f63;
        color: white;
    }
    .buy {
        background: #DC5C68;
        color: white;
    }
    .bought {
        background: #6179e0;
        color: white;
    }
</style>